const PAYMENT = 'payment';

export const NOTIFICATION_TYPES = {
  PAYMENT,
};
